module.exports = {
	"apiKey": "AIzaSyDre7pDZ4gsQFg8FtSC6ioogfuZ3TtS70M"
};


//////////////////
// WEBPACK FOOTER
// ./app/js/credentials/googleMaps.credentials.json
// module id = 428
// module chunks = 0